import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import image1 from "../../Assets/Projects/image1.jpg";
import image2 from "../../Assets/Projects/image2.jpg";
import image3 from "../../Assets/Projects/image3.jpg";
import image4 from "../../Assets/Projects/image4.jpg";
import image5 from "../../Assets/Projects/image5.jpg";
import image6 from "../../Assets/Projects/image6.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image1}
              isBlog={false}
              title="InsightEdge"
              description="Developed a real-time data analytics dashboard that leveraged machine learning to detect trends and anomalies in user behavior. Built RESTful APIs using FastAPI and created dynamic, interactive front-end components with React and Chart.js."
              ghLink="https://github.com/DragonWarrior812/python-fullstack"
              // demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image2}
              isBlog={false}
              title="Workshop React"
              description="Built a fully interactive custom shower design tool allowing customers to configure and visualize their ideal shower system. Implemented dynamic 3D rendering, price estimation logic, and complex form handling with validation. Optimized backend APIs for fast response times and integrated AWS services for scalable hosting."
              ghLink="https://github.com/DragonWarrior812/workshop-javascript"
              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image3}
              isBlog={false}
              title="CodeMind"
              description="Created an AI-powered assistant that provides real-time code suggestions, bug explanations, and refactoring tips. Fine-tuned transformer models on large datasets of open-source code and deployed the service with a Flask backend and React frontend."
              ghLink="https://github.com/DragonWarrior812/data-scientists"
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image4}
              isBlog={false}
              title="SmartScribe"
              description="Designed and deployed a web app that summarizes articles, research papers, or user-input text using NLP models. Integrated BERT for abstractive summarization and deployed the model with Streamlit for a smooth user interface."
              ghLink="https://github.com/DragonWarrior812/data-scientists"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image5}
              isBlog={false}
              title="MarketVision"
              description="Developed a tool that detects market patterns and signals using historical stock data and ML classifiers. Users can input a stock symbol and receive real-time forecasts with confidence scores and visualized predictions."
              ghLink="https://github.com/DragonWarrior812/fullstack-app"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={image6}
              isBlog={false}
              title="DevConnect"
              description="Built a social platform for developers to connect, share code snippets, and collaborate on projects. Focused on performance, responsive design, and a clean UI/UX. Implemented authentication, comments, likes, and real-time chat features."
              ghLink="https://github.com/DragonWarrior812/React-FullStack"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
